import React from 'react';
import PropTypes from 'prop-types';
import { Table, Spin } from 'antd';
import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';
import { useCollection } from 'react-firebase-hooks/firestore';

import Client from 'containers/app/client';

import DownloadTable from 'components/download-table';

import './style.css';

const columns = [
  {
    title: 'Organization',
    dataIndex: ['organization', 'name'],
  },
  {
    title: 'First Name',
    dataIndex: 'firstName',
  },
  {
    title: 'Last Name',
    dataIndex: 'lastName',
  },
  {
    title: 'Email',
    dataIndex: 'email',
  },
  {
    title: 'Claimed',
    dataIndex: 'claimed',
    render: (text) =>
      text ? (
        <CheckCircleTwoTone twoToneColor="#52c41a" />
      ) : (
        <CloseCircleTwoTone twoToneColor="#eb2f96" />
      ),
  },
];

const AdminInvitesWidget = ({ organizations }) => {
  const ref = Client.db.collection('admin_invites');
  const [collection, loading, error] = useCollection(ref);

  if (loading) return <Spin />;
  if (error) throw new Error(error);

  const data = collection.docs.map((doc) => {
    const docData = doc.data();
    const organization = organizations.find(
      (b) => b.id === docData.organizationId
    );

    if (!organization) return { ...docData, key: doc.id };
    return {
      ...docData,
      organization: organization.info,
      key: doc.id,
    };
  });

  return (
    <section className="admin-panel-section">
      <header className="admin-panel-header">
        <h2>Admin Invites</h2>
        <DownloadTable data={data} columns={columns} name="admin-invites" />
      </header>
      <Table dataSource={data} columns={columns} />
    </section>
  );
};

AdminInvitesWidget.propTypes = {
  organizations: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
    })
  ).isRequired,
};

export default AdminInvitesWidget;
